<div @fade class="report-container">
    <div class="sub-tittle">
        <div class="text">
            Aquí puedes obtener tu <br>
            informe de Salud Financiera
        </div>
    </div>
    <div class="left">
        <div class="option-container">
            <img src="./assets/temporals/download.svg" alt="">
            <div class="btn-container">
                <button *ngIf="showProgress2" class="download" id="downloadReport"
                    (click)="ReportDonwload('1')">Descargar</button>
                <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="!showProgress2"
                    mode="indeterminate">
                </mat-progress-bar>
            </div>
        </div>
    </div>
    <div class="right">
        <div class="option-container">
            <img src="./assets/temporals/email-report.svg" alt="">
            <div class="btn-container">
                <button *ngIf="showProgress" class="email" id="sendEmailReport" (click)="ReportMail('2')">Recibir por
                    email</button>
                <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="!showProgress"
                    mode="indeterminate">
                </mat-progress-bar>
            </div>
        </div>
    </div>
    <div class="message">
        <p>{{message}}</p>
    </div>
</div>